import { render, staticRenderFns } from "./addProduct.vue?vue&type=template&id=32caa822&scoped=true&"
import script from "./addProduct.vue?vue&type=script&lang=js&"
export * from "./addProduct.vue?vue&type=script&lang=js&"
import style0 from "./addProduct.vue?vue&type=style&index=0&id=32caa822&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32caa822",
  null
  
)

export default component.exports